module.exports = __webpack_public_path__ + "static/media/avatar-placeholder.e7ceafb2.png";